import {
    GroupedComboBoxRenderIcon,
    GroupedComboBoxRenderLabel,
    IGroupedComboBoxItem,
} from 'grouped-combobox-core';
import { canPinFont } from '../..';
import { DefaultStringResources } from '../../common/defaultStringResources';
import { emptyIconProps } from '../../common/iconNames';
import { IInternalFontFamily } from '../../common/internalFont';
import { IFontFamily, IStringResources } from '../FontPicker.types.shared';
import { createFontVariantSubmenu } from './createFontVariantSubmenu';

export function createFontItem(
    font: IFontFamily,
    pinnedFontKeys: string[],
    isSubscriber: boolean | undefined,
    onRenderLabel: GroupedComboBoxRenderLabel | undefined,
    onRenderIcon: GroupedComboBoxRenderIcon | undefined,
    allowFontInfoPane: boolean,
    allowPinning: boolean,
    stringResources?: IStringResources
): IGroupedComboBoxItem {
    const data: IInternalFontFamily = font;
    const canPin = allowPinning && canPinFont(font, !!isSubscriber);

    const { fontType, fontKey } = font;

    if (canPin && pinnedFontKeys.includes(fontKey)) {
        data.$isPinned = true;
    }

    // premium fonts do not have submenu
    const showSubmenu = isSubscriber || fontType !== 'premium';

    return {
        text: font.name,
        displayText: font.displayName,
        itemKey: font.fontKey,
        sections: showSubmenu
            ? createFontVariantSubmenu(
                  font,
                  canPin,
                  pinnedFontKeys,
                  stringResources || DefaultStringResources,
                  onRenderLabel,
                  onRenderIcon,
                  allowFontInfoPane
              )
            : undefined,
        data: data,
        secondaryText: font.isoLanguageCode,
        icon: emptyIconProps,
        // The only icons in the Office Fonts section are Pinning or Premium
        // so only add the renderIcon function if either of these are enabled
        onRenderIcon: canPin || !isSubscriber ? onRenderIcon : undefined,
        onRenderLabel: onRenderLabel,
    };
}
